var map = {
	"./Abaddon.png": "60f2",
	"./Alchemist.png": "daa2",
	"./AntiMage.png": "b431",
	"./Axe.png": "7cfe",
	"./BatRider.png": "6db2",
	"./BeastMaster.png": "f9fb",
	"./BountyHunter.png": "da7e",
	"./ChaosKnight.png": "1cae",
	"./Clockwerk.png": "790c",
	"./CrystalMaiden.png": "5c22",
	"./Dazzle.png": "a376",
	"./DeathProphet.png": "7f9a",
	"./Disruptor.png": "0240",
	"./Doom.png": "ea80",
	"./DragonKnight.png": "c3fb",
	"./DrowRanger.png": "95e2",
	"./Enchantress.png": "4d3e",
	"./Enigma.png": "8a12",
	"./Gyrocopter.png": "88b9",
	"./Juggernaut.png": "385e",
	"./KeeperOfTheLight.png": "9b73",
	"./Kunkka.png": "d513",
	"./Lich.png": "5411",
	"./Lina.png": "25a6",
	"./LoneDruid.png": "62be",
	"./Luna.png": "6e2c",
	"./Lycan.png": "46c5",
	"./Mars.png": "37c7",
	"./Medusa.png": "172f",
	"./Mirana.png": "f77b",
	"./Morphling.png": "d5e4",
	"./NaturesProphet.png": "6d0d",
	"./Necrophos.png": "35f6",
	"./OgreMagi.png": "93c0",
	"./OmniKnight.png": "84d6",
	"./PhantomAssassin.png": "7108",
	"./Puck.png": "7258",
	"./QueenOfPain.png": "75e2",
	"./Razor.png": "f332",
	"./Riki.png": "cc48",
	"./SandKing.png": "d5138",
	"./ShadowFiend.png": "662f",
	"./ShadowShaman.png": "ea50",
	"./Slardar.png": "5d75",
	"./Slark.png": "0e4c",
	"./Sniper.png": "f444",
	"./Sven.png": "9393",
	"./Techies.png": "1bea",
	"./TemplarAssassin.png": "c8e8",
	"./TerrorBlade.png": "958b",
	"./TideHunter.png": "6047",
	"./Timbersaw.png": "ff97",
	"./Tinker.png": "19fe",
	"./Tiny.png": "764b",
	"./TreantProtector.png": "9c57",
	"./TrollWarlord.png": "f4ce",
	"./Tusk.png": "0c69",
	"./Venomanger.png": "8609",
	"./Viper.png": "0f2c",
	"./WindRanger.png": "dc0f",
	"./WinterWyvern.png": "a02f",
	"./WitchDoctor.png": "aabf",
	"./Zeus.png": "1cfe"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "601e";